import { useState } from 'react';
import { hms2d, dms2d } from "../utils/functions";
import SesameButton from './Sesame';

function AddTarget({ onTargetAdded }) {
  const [formData, setFormData] = useState({
    name: '',
    ra: '',
    dec: ''
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    setMessage('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.ra || !formData.dec) {
      setMessage('<i class="bi bi-exclamation-diamond text-warning"></i> All fields are required.');
      return;
    }

    const newTarget = {
      name: formData.name,
      ra: hms2d(formData.ra),
      dec: dms2d(formData.dec)
    };

    onTargetAdded(newTarget);
    setFormData({ name: '', ra: '', dec: '' });
    setMessage(`<i class="bi bi-check text-success"></i> Target "${newTarget.name}" added.`);
    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <form onSubmit={handleSubmit} className="target-form">
      {/* ✅ Pasamos el nombre actual y los setters al botón */}
      

      <div id="targets-form" className='me-2'>
        <label htmlFor="name" className="d-none text-dark">Name</label>
        <input
          type="text"
          className="text-start me-1"
          id="name"
          name="name"
          placeholder="Add target name"
          value={formData.name}
          onChange={handleChange}
        />

         <SesameButton 
            name={formData.name}
            setRa={(ra) => setFormData(prev => ({ ...prev, ra }))}
            setDec={(dec) => setFormData(prev => ({ ...prev, dec }))}
        />

        <label htmlFor="ra" className="d-none text-dark">RA</label>
        <input
          title="Right ascension in +HH:MM:SS.s format (J2000)"
          type="text"
          className="text-end me-1 col-1"
          id="ra"
          name="ra"
          placeholder="+HH:MM:SS.s"
          value={formData.ra}
          onChange={handleChange}
          pattern="^((?:[01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]?\.?\d+))|(00:00:00)$"
        />


        <label htmlFor="dec" className="d-none text-dark">Dec</label>
        <input
          title="Declination in +DD:MM:SS.s format (J2000)"
          type="text"
          className="text-end me-1 col-1"
          id="dec"
          name="dec"
          placeholder="+DD:MM:SS.s"
          value={formData.dec}
          onChange={handleChange}
          pattern="^[+\-]?([0-9][0-9]):([0-5][0-9]):([0-5][0-9]?\.?\d+)$"
        />

        <button type="submit" className="">
          <i className="bi bi-plus-square text-secondary fs-4"></i>
        </button>
      </div>

      {message && (
        <p
          className={`message ${
            message.startsWith('<i class="bi bi-exclamation-diamond text-warning"></i>')
              ? 'error'
              : 'success'
          }`}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
    </form>
  );
}

export default AddTarget;
